/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import "./ConfirmModal.scss";
import { SecondaryBtn, PrimaryBtn } from "../../buttons/Buttons";
import CloseIcon from "@mui/icons-material/Close";

/**
 *
 * Renders a modal with content, cancel and confirm buttons
 */
interface IProps {
  dialogContentText?: string | React.ReactNode;
  dialogTitle?: string;
  onConfirmClick?: () => void;
  open: boolean;
  onCancelClick: () => void;
  onCloseClick: () => void;
  primaryBtnText?: string;
}
const ConfirmDialog = (props: IProps) => {
  const [open, setOpen] = useState(props.open);

  return (
    <Dialog
      open={props.open}
      // onClose={()=>setCancelOpen(false)}
      sx={{ backdropFilter: "blur(3px)" }}
    >
      <DialogTitle className="dialogHeading" id="dialog-title">
        {props.dialogTitle}
        <IconButton
          edge="end"
          color="inherit"
          aria-label="close"
          sx={{ marginLeft: "auto" }}
          onClick={() => {
            setOpen(false);
            props.onCloseClick && props.onCloseClick();
          }}
        >
          <CloseIcon data-testid="closeIcon" />
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="dialogInfo">
          {props.dialogContentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          paddingRight: 4,
          paddingBottom: 4,
        }}
      >
        <SecondaryBtn
          btnText="Cancel"
          onClick={() => props.onCancelClick && props.onCancelClick()}
          ariaLabel=""
        />
        <PrimaryBtn
          btnText={props.primaryBtnText ? props.primaryBtnText : "Create"}
          onClick={() => props.onConfirmClick && props.onConfirmClick()}
          ariaLabel=""
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
